import React from 'react';
import { Accordion, Card, Row, Col, Button, Alert } from 'react-bootstrap';
import PublicEventAddDetail from './PublicEventAddDetail';
import PublicEventLocation from './PublicEventLocation';
import PublicEventSelectCategory from './PublicEventSelectCategory';
import { translate } from "react-i18next";
import '../event/EventAddTabs.css';
import { sendJson } from '../../backend/Backend';
import AuthenticationService from '../../backend/AuthenticationService';
import {CREATED, TEMPORARY, fileUpload } from '../../backend/Backend';
import { Redirect } from 'react-router-dom';
import { getDateDisplayValue } from '../../backend/UIUtils';
import { BLUE, GREY_LIGHT } from '../../backend/Colors'
import i18n from "i18next";
import { PUB_CATEGORIES } from '../../backend/Data';


function emptyEventDetail() {
  return {
    startDate: new Date(), endDate: new Date(), eventCategory: '', title: '', description: '', commentsEnabled: '', location: '', limitParticipants: '', maxParticipants: '', limitDateChoose: '',
    publicEmail: '', publicPhoneNr: '', publicMobileNr: '', eventLink: '', bookingLink: '', userMinAge: '', useBookingService: '', mediaLink: '', videoLink: '', eventType: 'PUBLIC',
    locationName: '', street: '', zipcode: '', city: '', country: 'CH', canton: '', file: null, bookingType: 'INTERN'
  };
}


function emptyUserInfo() {
  return { username: '', email: '', id: '' };
}

class PublicEventAddPages extends React.Component {
  constructor(props) {
    super(props);
    this.saveEvent = this.saveEvent.bind(this);
    this.updateModel = this.updateModel.bind(this);
    this.executeFileUpload = this.executeFileUpload.bind(this);
    this.fileChanged = this.fileChanged.bind(this);
    this.removeFile = this.removeFile.bind(this);

    this.goTo = this.goTo.bind(this);

    this.state = {
      event: { eventDetail: emptyEventDetail(), eventAddUser: emptyUserInfo(), eventDates: [] },
      file: null,
      key: "0",
      pageKeys: [],
      message: '',
      redirect: false,
      redirectLink: ''
    }
  }

  async componentDidMount() {
    if (AuthenticationService.isUserLoggedIn()) {
      let user = AuthenticationService.getLoggedUser();
      if (user != null) {
        let oldState = this.state;
        let oldEvent = this.state.event;
        const newEvent = {
          ...oldEvent,
          eventAddUser: { username: user.name, email: user.email, id: user.id }

        };
        this.setState({
          ...oldState,
          event: newEvent
        });
      }

    }
  }

  updateModel(name, value, action) {
    let oldState = this.state;
    console.log("oldState---- this.state : " + JSON.stringify(this.state));
    let oldEvent = this.state.event;
    if (name === "eventDates") {
      if (action === 'EVENTDATE_ADD') {
        oldEvent.eventDates = [].concat(oldEvent.eventDates, [value]);
      }
      if (action === 'EVENTDATE_REMOVE') {
        oldEvent.eventDates = oldEvent.eventDates.filter(eventDate => eventDate.startDate !== value.startDate);
      }

    } else if (name === "eventCategory") {
      oldEvent.eventDetail.title = value.title;
      oldEvent.eventDetail.eventCategory = value.eventCategory;
      oldEvent.eventDetail.subCategory = value.subCategory;
      oldEvent.eventDetail.description = value.description;
    } else if (name === "eventDetail") {//eventLocation
   
      oldEvent.eventDetail.startDate = value.startDate;
      oldEvent.eventDetail.endDate = value.endDate;
      oldEvent.eventDetail.eventLink = value.eventLink;
      oldEvent.eventDetail.userMinAge = value.userMinAge;
      oldEvent.eventDetail.bookingType = value.bookingType;
      oldEvent.eventDetail.maxParticipants = value.maxParticipants;
      oldEvent.eventDetail.bookingLink = value.bookingLink;
    } else if (name === "eventLocation") {//eventLocation
      oldEvent.eventDetail.locationName = value.locationName;
      oldEvent.eventDetail.street = value.street;
      oldEvent.eventDetail.zipcode = value.zipcode;
      oldEvent.eventDetail.city = value.city;
      oldEvent.eventDetail.canton = value.canton;
      oldEvent.eventDetail.country = value.country;
    } else if (name === "eventAddUser") {
      oldEvent.eventAddUser = value;
    }
   
    this.setState({
      ...oldState,
      event: oldEvent
    });
  }

  fileChanged(file) {
    let oldState = this.state;
    this.setState({
      ...oldState,
      file: file
    });
  }


  removeFile() {
    let oldState = this.state;
    this.setState({
      ...oldState,
      file: null
    });
  }

  saveEvent(status) {
    const { event } = this.state;
    event.eventDetail.eventStatus = status;
    event.eventDetail.lang = i18n.language;

    sendJson('post', 'p-events/createEvent', event).then(
      received => {
        console.log("Saved Eventid: " + JSON.stringify(received));

        //if(received.ok){
        let oldState = this.state;
        this.setState({
          ...oldState,
          message: 'successSaved'
        });
        setTimeout(() => this.setState({ ...oldState, message: '' }), 5000);
        if (received.ok && received.id) {
          this.executeFileUpload(this.state.file, received.id)
        }
        //}
      });

  }

  executeFileUpload(file, id) {
    if (!file) {
      return;
    }

    fileUpload(file, id, 2);
    let oldState = this.state;
    this.setState({
      ...oldState,
      message: 'fileUploaded'
    });
    setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
  }


  onSelectTab(name) {
    let oldState = this.state;
    let oldPageKeys = this.state.pageKeys;
    oldPageKeys = [].concat(oldPageKeys, [name]);
    this.setState({ ...oldState, key: name, pageKeys: oldPageKeys });
  }

  goTo(link) {
    let oldState = this.state;
    this.setState({
      ...oldState,
      event: {
        eventDetail: emptyEventDetail(), eventAddUser: emptyUserInfo(), eventDates: []
      },
      redirect: true,
      redirectLink: link
    })
  }

  getEventCategoryValue() {
    if (this.state.event.eventDetail.eventCategory) {
      let category = PUB_CATEGORIES.find(e => e.code === this.state.event.eventDetail.eventCategory);
      if (!category) {
        return "";
      }
      if (this.state.event.eventDetail.subCategory) {
        let subCat = category.subs.find(e => e.code === this.state.event.eventDetail.subCategory);
        //TODO lang
        if (subCat) {
          return category.de + " / " + subCat.de
        }
      }
      return category.de;
    }
    return '';
  }

  getTitleValue(at) {
    let value = (this.state.event.eventDetail.title ? (this.state.event.eventDetail.title.substring(0, 30)) + "... " : '');
    value += this.state.event.eventDetail.startDate ? (at + " " + getDateDisplayValue(this.state.event.eventDetail.startDate)) : "";
    return value;
  }

  getLocalValue() {
    // locationName: '', street: ''
    if (this.state.event.eventDetail.locationName) {
      return this.state.event.eventDetail.locationName.substring(0, 30) + "... ";
    }
    if (this.state.event.eventDetail.street) {
      return this.state.event.eventDetail.street.substring(0, 30) + "... ";
    }
    return null;
  }

  resolveBg(key) {
    return this.state.key === key ? "bg-success" : "bg-white";
  }

  resolveClassName(key) {
    return this.state.key === key ? "bg-light" : "bg-white";
  }



  resolveColor(key) {
    return this.state.key === key ? "white" : BLUE;//GREEN ;
  }

  resolveIconColor(key) {
    return this.state.key === key ? "white" : BLUE;
  }

  // <span className="addTitle">{this.state.event.eventDetail.title  ? this.getTitleValue(atValue) : t("wasUndWann") }</span>
  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectLink} />
    }
    const { t } = this.props;
    // || this.state.event.eventDetail.location !== ''
    let validateDetail = this.state.event.eventDetail.title !== '' || this.state.event.eventDetail.comment !== '' ;
    let userValidate = this.state.event.eventAddUser.id > 0 || this.state.event.eventAddUser.email !== '' || this.state.event.eventAddUser.id > 0;
    let selectValid = this.state.event.eventDetail.title !== '' && this.state.event.eventDetail.eventCategory && this.state.event.eventDetail.eventCategory !== '0'
    let lang = i18n.language;
    if (!lang) {
      lang = 'de'
    }
    let atValue = t("at");  //lang === 'de' ? 'am': (lang === 'fr'? 'a': (lang === 'en' ? 'at': 'de'));
    return (
      <div className=" fluid container-fluid2  mt-5 ">
        <Row className="justify-content-md-center" >
          <Col xl={12} lg={12} className=" cMaxWidth justify-content-xl-center d-relative  ">
            <Accordion defaultActiveKey="0" activeKey={this.state.key}>

              <Card>
                <Card.Header className={this.resolveClassName('0')} >
                  <Accordion.Toggle as={Button} variant="link" eventKey="0" className="text-primary" onClick={() => this.onSelectTab('0')}>
                    <i className="text-primary fa fa-folder-open s24 mr-3 ml-0 w24" ></i>
                    <span className="addTitle">{this.state.event.eventDetail.eventCategory ? this.getEventCategoryValue() : t("KategorienAuswahl")}</span>
                  </Accordion.Toggle>

                </Card.Header>

                <Accordion.Collapse eventKey="0">
                  <Card.Body style={{ "background": GREY_LIGHT }}>
                    <PublicEventSelectCategory updateModel={this.updateModel.bind(this)} detailModel={this.state.event.eventDetail}
                      fileChanged={this.fileChanged.bind(this)}
                      removeFile={this.removeFile.bind(this)} />
                    {!this.state.pageKeys.includes('1') ?
                      <Button variant="primary mt-5 mb-2" onClick={() => this.onSelectTab('1')} className="float-right mt-2 mr-1" disabled={!selectValid} >{t("Weiter")}</Button>
                      :
                      ''
                    }

                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              {(this.state.key === '1' || this.state.pageKeys.indexOf('1') >= 0) ? (
                <Card>
                  <Card.Header className={this.state.key === '1' ? "bg-light" : "bg-white"}>
                    <Accordion.Toggle as={Button} variant="link" eventKey="1" className="text-primary" onClick={() => this.onSelectTab('1')}>
                      <i className="text-primary fa fa-question s24 mr-3 ml-0 w24" ></i>

                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body style={{ "background": GREY_LIGHT }}>
                      <PublicEventAddDetail updateModel={this.updateModel.bind(this)} detailModel={this.state.event.eventDetail} />
                      {!this.state.pageKeys.includes('2') ?
                        <Button variant="primary mt-5 mb-2" onClick={() => this.onSelectTab('2')} className="float-right mt-2 mr-1" disabled={validateDetail !== true || !userValidate} >{t("Weiter")}</Button>
                        :
                        ''
                      }

                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ) : (<div></div>)}

              {(this.state.key === '2' || this.state.pageKeys.indexOf('2') >= 0) ? (
                <Card>
                  <Card.Header className={this.state.key === '2' ? "bg-light" : "bg-white"}>
                    <Accordion.Toggle as={Button} variant="link" eventKey="2" className="text-primary " onClick={() => this.onSelectTab('2')}>
                      <i className=" text-primary fa fa-map-marker-alt s24 mr-3 w24" ></i>
                      <span className="addTitle">{this.getLocalValue() ? this.getLocalValue() : t("wo")}</span>
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="2"  >
                    <Card.Body style={{ "background": GREY_LIGHT }}>
                      <Row className="justify-content-md-center">
                        <Col>
                          <PublicEventLocation updateModel={this.updateModel.bind(this)} detailModel={this.state.event.eventDetail} />
                        </Col>
                      </Row>
                      <Row className="justify-content-md-center">
                        <Col className={'float-right '}>
                          <Button variant="outline-primary" onClick={() => this.saveEvent(CREATED)} className={'float-right  mt-3 '} disabled={validateDetail !== true} size="sm" >
                            <span className="addTitle" disabled={validateDetail !== true} >{t("finish")}</span></Button>
                          <Button variant="outline-primary" onClick={() => this.saveEvent(TEMPORARY)} className={'float-right mr-3 mt-3 '} disabled={validateDetail !== true} size="sm">
                            <span className="addTitle" >{t("temporarySave")}</span></Button>
                          <Button variant="outline-primary" onClick={() => this.goTo("/")} className={'float-right mr-3 mt-3 '} disabled={validateDetail !== true} size="sm">
                            <span className="addTitle" >{t("cancel")}</span></Button>
                        </Col>
                      </Row>

                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ) : (<div></div>)}
            </Accordion>
          </Col>
        </Row>
        {this.state.message ?
          <Alert variant="info">
            {t(this.state.message)}
          </Alert>
          :
          ''
        }
      </div>);
  }
}

export default translate("translations")(PublicEventAddPages);
